var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletLoans = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#02769D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.214 23.6a3.213 3.213 0 0 0 3.218-3.217 3.225 3.225 0 0 0-3.218-3.217 3.225 3.225 0 0 0-3.217 3.217c-.019 1.78 1.436 3.218 3.217 3.218zM21.799 22.116a3.213 3.213 0 0 0 3.218-3.218 3.225 3.225 0 0 0-3.218-3.217 3.225 3.225 0 0 0-3.218 3.217 3.225 3.225 0 0 0 3.218 3.218zM14.621 27.066h-1.725a.745.745 0 0 0-.75.75v5.923c0 .42.332.752.75.752h1.725v-7.425zM37.661 26.106a3.577 3.577 0 0 0-5.194 0l-2.297 2.39-.936.975a2.025 2.025 0 0 1-1.431.626h-4.558a.788.788 0 0 1-.778-.755c-.018-.46.336-.827.76-.827h4.629c.936 0 1.749-.699 1.908-1.655.035-.221.053-.442.053-.68 0-.442-.336-.792-.76-.792h-2.544c-.83 0-1.625-.386-2.473-.809-.884-.441-1.803-.883-2.863-.956a7.596 7.596 0 0 0-2.791.312c-.972.295-1.678 1.196-1.767 2.244h-.017v7.817h13.162c.9 0 1.749-.368 2.403-1.03l5.494-5.72c.3-.331.3-.828 0-1.14z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletLoans);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-loans.a1c16be3bca725c5705118306cd0dc85.svg";